import { request } from './index';
import axios from '@/axios';

//Orgãos para listar na tela
export async function getOrgonsList(type_orgon) {
    try {
      const { data } = await axios.get(`/orgon/filter`, { params: {
        name: '',
        type_orgon: type_orgon,
        hospital: ''
      }});
        return data.data
    }catch (error){
        return error  
    }
}

export async function getTypeSurgery() {
    return await request("GET", `/type_captations`)
}

//OPOS e OPCs
export async function getOposeOpcs(id) {
    return await request("GET", `/references/by_type_reference/${id}`)
}

//Soluções de Preservação
export async function getPreservationSolutions() {
    return await request("GET", "/preservation_solutions")
}
//Amostra Sanguínea
export async function getBloodCollection() {
    return await request("GET", "/blood_sample_collections")
}
//Acondicionamento de tecidos
export async function getFabricConditionings() {
    return await request("GET", "/fabric_conditionings")
}
//Descrições cirúrgicas
export async function getSurgicalDescriptions() {
    return await request("GET", "/surgical_descriptions")
}

//Razão da não cirurgia 
export async function getReasonsCaptations(typeCaptation) { 
    try {
      const { data } = await axios.get(`/reason_not_captureds/list`, { params: {
        description: '',
        type: !typeCaptation ? '1' : ' ',
        type_captation: typeCaptation,
      }});
 
        return data.data
    }catch (error){
        return error  
    } 
}

//Razão da não captação de cada orgão ou tecido
export async function getReasonsForOrgons(type_orgon) {   
    const onlyForOrgansId = 2
    try {
      const { data } = await axios.get(`/reason_not_captureds/filter`, { params: {
        description: '',
        type_orgon: type_orgon,
        type: onlyForOrgansId 
      }});
        return data.data
    }catch (error){
        return error  
    } 
}

export async function getCaptationsTeams(id) { 
    try {
      const { data } = await axios.get(`/captations_team/${id}`);
        return data
    }catch (error){
        return error  
    } 
}

//Lista de profissões
export async function getProfissionsList() {
    return await request("GET", "/profissions/list")
}

//Membros
export async function getMembers() {
    return await request("GET", "/members")
}

//Unidades
export async function getUnities() {
    return await request("GET", "/unities")
}
 
//Orgãos captados
export async function getOrgonsStillNotCaptureds(id, type_id) { 
    try {
      const { data } = await axios.get(`orgons_captured/get_by_donor_team_doesnt_have/${id}`, { params: {
        status: '',
        type_orgon: type_id,
      }});
        return data.data
    }catch (error){
        return error  
    } 
}
